import { Box, Button, Card, CardContent, Chip, Typography } from '@mui/material';

import type { WizardStepData } from '../../types/wizard';

interface WizardPreviewStepProps {
  data: WizardStepData;
  onNext: () => void;
  onBack: () => void;
}

export const WizardPreviewStep = ({ data, onNext, onBack }: WizardPreviewStepProps) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Review Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Review your integration settings before deployment
      </Typography>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Integration Name
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {data.name}
          </Typography>

          <Typography variant="subtitle2" gutterBottom>
            Source Environment
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {data.sourceEnv}
          </Typography>

          <Typography variant="subtitle2" gutterBottom>
            Destination Environment
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {data.destinationEnv}
          </Typography>

          <Typography variant="subtitle2" gutterBottom>
            Selected Objects
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {data.selectedObjects?.map((obj) => (
              <Chip key={obj} label={obj} size="small" />
            ))}
          </Box>

          <Typography variant="subtitle2" gutterBottom>
            Field Mappings
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {data.mappings?.length || 0} mappings configured
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Button variant="contained" onClick={onNext}>
          Next: Deploy
        </Button>
      </Box>
    </Box>
  );
};
